import React, {Component} from 'react'
import Image from "../../../../common/image/image.component.jsx"
import Icon from "../../../../common/icon/icon.component.jsx";
import {FormattedMessage} from "react-intl";
import SectionWrapper from "../../sectionwrapper.component.jsx";

class ImageRowContentSection extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            className: this.props.className || '',
            section: this.props.section || null,
            variables: this.props.variables || null,
            editable: this.props.editable || false,
            edition: this.props.edition || false,
            isPdf: this.props.isPdf || false,
            onEdit: this.props.onEdit || function(){},
            id: this.props.id || '',
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            className: nextProps.className || '',
            section: nextProps.section || null,
            variables: nextProps.variables || null,
            isPdf: nextProps.isPdf || false,
            id: nextProps.id || '',
        })
    }

    render() {
        if (!this.state.section) {
            return <div />
        }
        let alignment = "text-center"
        switch (this.state.section.attributes.content.alignment) {
            case 'center':
                alignment = "text-center"
                break
            case 'left':
                alignment = "text-left"
                break
            case 'right':
                alignment = "text-right"
                break
        }
        let verticalAlignment = "my-auto"
        switch (this.state.section.attributes.content.verticalAlignment) {
            case 'middle':
                verticalAlignment = "my-auto"
                break
            case 'top':
                verticalAlignment = ""
                break
            case 'bottom':
                verticalAlignment = "mt-auto"
                break
        }
        const hide = this.state.editable ? '' : 'd-none'



        let everyImage = [];
        let imageContent = this.state.section.attributes.content
        const columnWidthMd = 12/imageContent.nbColumns //bootstrap column width for large (md-sized +) screens
        let columnWidthSmall = 12 //bootstrap column width for small (xs & sm-sized) screens
        if(this.state.isPdf) {
            columnWidthSmall = columnWidthMd //pdf rendering is always done as xs, we need to take that into account
        }
        for (let i = 0; i < imageContent.nbColumns; i++) {
            everyImage.push(
                <div key={"imageRow"+i} className={'col-'+ columnWidthSmall +' col-md-' + columnWidthMd +' '+ alignment+' '+ verticalAlignment}>
                    {imageContent.imageCells && imageContent.imageCells[i] ? <Image
                            image={imageContent.imageCells[i].image}
                            imageId={imageContent.imageCells[i].imageId}
                            size="large"
                            imageClassName={"w-" + imageContent.imageCells[i].size}
                            linkUrl={imageContent.imageCells[i].linkUrl}

                        /> :
                        <div className={hide}>
                            <p className={"section-empty-message m-0 text-left"}>
                                {this.state.section.attributes.internalName}
                            </p>
                            <p className={"section-empty-message text-left"}>
                                <Icon value={"image"} />
                                <small className={"ml-2"}>
                                    <FormattedMessage
                                        id="templates.sections.image.empty_message"
                                        defaultMessage="Image missing"
                                    />
                                </small>
                            </p>
                        </div>
                    }
                </div>
            )
        }

        return (
            <SectionWrapper
                id={this.state.id}
                section={this.state.section}
                onEdit={this.state.onEdit}
                editable={this.state.editable}
                variables={this.state.variables}
            >
                <div className='py-2 col-12 '>
                    <div className="row">
                        {everyImage}
                    </div>
                </div>
            </SectionWrapper>
        );
    }
}

export default ImageRowContentSection


// WEBPACK FOOTER //
// ./src/template/sections/content/image-row/section.component.jsx